import { Component } from "react";
import axios from "axios";
import Select from "react-select";
import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import logo from "./assets/icontransparent.png";
import DashboardMatchups from "./DashboardMatchups";
import DashboardStanding from "./DashboardStanding";
import DashboardStats from "./DashboardStats";
import DashboardTeamMatchups from "./DashboardTeamMatchups";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DashboardPreCampaign from "./DashboardPreCampaign";

const config = require("../config.json");
import "../../src/dashboard.css";

export default class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.getTeamAveragePoints = this.getTeamAveragePoints.bind(this);
    this.getWeekAveragePointsLeagueTeams =
      this.getWeekAveragePointsLeagueTeams.bind(this);
  }

  state = {
    leagues: [],
    shownLeagues: [],
    companies: [],
    teams: [],
    teamSelected: null,
    campaign: {},
    currentWeek: 1,
    headerText: "Dashboard",
    leagueHeaderText: "Dashboard",
    view: "league",
    loading: true,
    currentLeague: {},
    currentLeagueIdx: 0,
    currentCompany: null,
    showHeaderControls: true,
  };

  headerControlsTimeout = null;

  fetchUserHighscore = async (company) => {
    try {
      const response = await axios.get(
        `${config.api.invokeUrl}/companies/${company.id}/highscore/123/test`,
      );

      return await response.data;
    } catch (error) {
      console.error(error);
    }
  };

  fetchCompanyHighscore = async (company) => {
    try {
      const response = await axios.get(
        `${config.api.invokeUrl}/campaign/${company.campaignId}/companyhighscore/${company.id}`,
      );

      return await response.data;
    } catch (error) {
      console.error(error);
    }
  };

  fetchLeagues = async (campaignId) => {
    try {
      const res = await axios.get(
        `${config.api.invokeUrl}/campaign/${campaignId}/leagueteams`,
      );
      const leagues = res.data;

      return leagues;
    } catch (err) {
      console.log(err);
    }
  };

  fetchCompanies = async () => {
    try {
      const res = await axios.get(`${config.api.invokeUrl}/companies`);
      const companies = res.data;
      this.setState({ companies });
    } catch (err) {
      console.log(err);
    }
  };

  fetchCampaigns = async () => {
    try {
      const res = await axios.get(`${config.api.invokeUrl}/campaign`);
      const campaigns = res.data;
      const activeCampaigns = campaigns.filter(
        (campaign) => !campaign.campaignHidden,
      );
      this.setState({ campaigns: activeCampaigns });
    } catch (err) {
      console.log(err);
    }
  };

  fetchCampaign = async (campaignId) => {
    try {
      const res = await axios.get(
        `${config.api.invokeUrl}/campaign/${campaignId}`,
      );
      return res.data?.Item;
    } catch (err) {
      console.log(err);
      return null;
    }
  };

  getTeamsFromLeagues = async (leagues, companyId) => {
    let teams = [];
    leagues.forEach((league) => {
      teams = teams.concat(league.teams);
    });

    if (companyId) {
      teams = teams.filter((team) => team.teamOrganization === companyId);
    }

    teams = teams.map((team) => {
      return { ...team, value: team.id, label: team.teamName };
    });

    teams.unshift({ value: "", label: "Overblik" });

    console.log(teams);

    this.setState({ teams });
  };

  handleInputChange(event) {
    const value = event.target.value;
    const name = event.target.name;
    this.setState({
      newTeam: {
        ...this.state.newTeam,
        [name]: value,
      },
    });
  }

  changeCompany = async (e) => {
    const company = this.state.companies.find(
      (company) => company.id == e.value,
    );

    if (!company) {
      this.setState({ loading: false });
      return;
    }

    this.setState({ view: "league", loading: true, currentCompany: company });
    const campaign = await this.fetchCampaign(company.campaignId);
    const leagues = await this.fetchLeagues(company.campaignId);
    const highscore = await this.fetchUserHighscore(company);
    const companyhighscore = await this.fetchCompanyHighscore(company);

    console.log(leagues);

    const filteredLeagues = leagues.filter((league) =>
      league.teams.some((team) => team.teamOrganization === company.id),
    );

    console.log(filteredLeagues);

    this.setState({
      leagues: filteredLeagues,
      shownLeagues: filteredLeagues,
      currentLeague: filteredLeagues[0],
      campaign,
      companyhighscore,
      highscore,
    });

    this.getTeamsFromLeagues(filteredLeagues, company.id);

    let currentWeek = campaign.currentWeek ?? 0;

    if (currentWeek > 0 && campaign.weekAmount < currentWeek) {
      currentWeek = campaign.weekAmount;
    }

    this.setState({
      headerText: e.label,
      leagueHeaderText: e.label,
      currentWeek,
      view: "league",
      loading: false,
      currentCompany: company,
    });
  };

  changeToTeamView = (e) => {
    if (e.value == "") {
      this.setState({
        headerText: this.state.leagueHeaderText,
        view: "league",
        shownLeagues: this.state.leagues,
      });
      return;
    }

    const team = this.state.teams.find((team) => team.value == e.value);
    let filteredLeagues = [];
    this.state.leagues.forEach((league) => {
      league.teams.forEach((leagueTeam) => {
        if (team.id == leagueTeam.id) {
          filteredLeagues = [];
          filteredLeagues.push(league);
        }
      });
    });

    this.setState({
      teamSelected: team,
      view: "team",
      headerText: e.label,
      shownLeagues: filteredLeagues,
    });
  };

  componentDidMount = () => {
    if (this.props.auth?.user?.admin) {
      this.fetchCompanies();
    } else if (this.props.auth?.user?.companyId) {
      this.loadCompanyDashboard(this.props.auth.user.companyId);
    }

    this.resetHeaderControlsTimeout();
    this.refreshInterval = setInterval(
      this.refreshDashboardData,
      5 * 60 * 1000,
    );
  };

  componentDidUpdate(prevProps) {
    const prevUser = prevProps.auth?.user;
    const nextUser = this.props.auth?.user;

    if (!prevUser?.admin && nextUser?.admin) {
      this.fetchCompanies();
    }

    if (prevUser?.companyId !== nextUser?.companyId && nextUser?.companyId) {
      this.loadCompanyDashboard(nextUser.companyId);
    }
  }

  componentWillUnmount = () => {
    clearTimeout(this.headerControlsTimeout);
    clearInterval(this.refreshInterval);
  };

  resetHeaderControlsTimeout = () => {
    clearTimeout(this.headerControlsTimeout);
    this.setState({ showHeaderControls: true });
    this.headerControlsTimeout = setTimeout(() => {
      this.setState({ showHeaderControls: false });
    }, 3500);
  };

  refreshDashboardData = async () => {
    const company = this.state.currentCompany;
    if (!company) return;

    try {
      const [highscore, companyhighscore, leagues] = await Promise.all([
        this.fetchUserHighscore(company),
        this.fetchCompanyHighscore(company),
        this.fetchLeagues(company.campaignId),
      ]);

      const filteredLeagues = leagues.filter((league) =>
        league.teams.some((team) => team.teamOrganization === company.id),
      );

      this.setState({
        highscore,
        companyhighscore,
        leagues: filteredLeagues,
        shownLeagues: filteredLeagues,
        currentLeague:
          filteredLeagues[this.state.currentLeagueIdx] || filteredLeagues[0],
      });

      this.getTeamsFromLeagues(filteredLeagues, company.id);
    } catch (err) {
      console.error("Dashboard refresh failed:", err);
    }
  };

  loadCompanyDashboard = async (companyId) => {
    this.setState({ loading: true });

    try {
      const response = await axios.get(`${config.api.invokeUrl}/companies`);
      const companies = response.data;
      const company = companies.find((item) => item.id === companyId);

      this.setState({ companies });

      if (!company) {
        this.setState({ loading: false });
        return;
      }

      await this.changeCompany({
        value: company.id,
        label: company.companyName,
      });
    } catch (error) {
      console.error(error);
      this.setState({ loading: false });
    }
  };

  changeCurrentWeek = (week) => {
    let currentWeek = parseInt(this.state.currentWeek) + week;
    if (this.state.leagues[0].weekAmount < currentWeek) {
      currentWeek = this.state.leagues[0].weekAmount;
    }
    if (currentWeek == 0) {
      currentWeek = 1;
    }
    this.setState({ currentWeek });
  };

  changeLeague = (idx) => {
    let leagueIdx = parseInt(this.state.currentLeagueIdx) + idx;
    if (this.state.leagues.length - 1 < leagueIdx) {
      leagueIdx = 0;
    }
    if (leagueIdx < 0) {
      leagueIdx = this.state.leagues.length - 1;
    }
    this.setState({
      currentLeagueIdx: leagueIdx,
      currentLeague: this.state.leagues[leagueIdx],
    });
  };

  getTeamAveragePoints(team, currentWeek) {
    let memberAmount = 1;
    memberAmount = team?.points?.weekPoints["amountOfUsers_week" + currentWeek];

    if (isNaN(memberAmount)) {
      if (!isNaN(team.activeUserCount)) {
        memberAmount = team.activeUserCount;
      }

      memberAmount = 1;
    }

    if (team?.points?.weekPoints[currentWeek]) {
      let avgPoints = team?.points.weekPoints[currentWeek] / memberAmount;

      if (isNaN(avgPoints)) {
        avgPoints = 0;
      }

      return avgPoints;
    } else {
      return 0;
    }
  }

  getWeekAveragePointsLeagueTeams(currentWeek, leagueTeams) {
    let leagueWeekTotalPoints = 0;
    leagueTeams.forEach((team) => {
      if (team.points.weekPoints[currentWeek]) {
        leagueWeekTotalPoints += this.getTeamAveragePoints(team, currentWeek);
      }
    });
    let leagueWeekAverage = leagueWeekTotalPoints / leagueTeams.length;
    return parseInt(leagueWeekAverage.toFixed(0));
  }

  findTeam = (teamId, leagueId) => {
    const league = this.state.leagues.find((league) => league.id == leagueId);
    let team = league.teams.find((team) => team.id == teamId);
    if (team == undefined) {
      return "average";
    }
    return team;
  };

  getTeamRankData = () => {
    let allTeams = [];
    this.state.shownLeagues.forEach((league) => {
      allTeams = allTeams.concat(league.teams);
    });
    const ranked = this.rankTeams([...allTeams]);
    const teamIdx = ranked.findIndex(
      (t) => t.id === this.state.teamSelected?.id,
    );
    return {
      rank: teamIdx >= 0 ? teamIdx + 1 : "-",
      companyAmount: ranked.length,
    };
  };

  rankTeams = (teams) => {
    const compare = (a, b) => {
      if (a.wins > b.wins) {
        return -1;
      }
      if (a.wins < b.wins) {
        return 1;
      }
      if (a.wins == b.wins) {
        if (a.avgTotalPoints > b.avgTotalPoints) {
          return -1;
        }
        if (a.avgTotalPoints < b.avgTotalPoints) {
          return 1;
        }
      }
      return 0;
    };
    return teams.sort(compare);
  };

  render() {
    const options = this.state.companies.map((company) => {
      return { value: company.id, label: company.companyName };
    });

    return (
      <>
        <section className="dashboard">
          <div className="dashboard container">
            <div className="header">
              <div className="is-flex align-center">
                <img className="logo" src={logo}></img>
                <h1 className="header-text dark-grey">Klimakampen</h1>
                {this.state.currentCompany && (
                  <>
                    <span className="header-separator">|</span>
                    {this.state.currentCompany.avatarId && (
                      <img
                        className="logo-company"
                        src={`${config.s3.organizationImagesUrl}${this.state.currentCompany.avatarId}`}
                      />
                    )}
                    <h1 className="header-text dark-grey">
                      {this.state.headerText}
                    </h1>
                  </>
                )}
              </div>
              <div
                className="league-selects"
                onMouseMove={this.resetHeaderControlsTimeout}
                onMouseEnter={this.resetHeaderControlsTimeout}
                onTouchStart={this.resetHeaderControlsTimeout}
              >
                {this.props.auth?.user?.admin && (
                  <Select
                    onChange={this.changeCompany}
                    name="companies"
                    isLoading={options.length == 0}
                    options={options}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    placeholder="Vælg virksomhed"
                    styles={{
                      control: (baseStyles, state) => ({
                        ...baseStyles,
                        width: 300,
                        color: "whitesmoke",
                        cursor: "pointer",
                      }),
                      option: (baseStyles, state) => ({
                        ...baseStyles,
                        color: "black",
                      }),
                      placeholder: (baseStyles, state) => ({
                        ...baseStyles,
                        color: "#3A3A3A",
                        fontSize: 20,
                      }),
                    }}
                  />
                )}

                <button
                  type="button"
                  className={`dashboard-logout-btn ${
                    this.state.showHeaderControls ? "" : "hidden"
                  }`}
                  onClick={this.props.auth.handleLogout}
                >
                  Log ud
                </button>

                <Select
                  onChange={this.changeToTeamView}
                  name="teams"
                  isDisabled={this.state.teams.length == 0}
                  options={this.state.teams}
                  className={`basic-multi-select dashboard-team-select ${
                    this.state.showHeaderControls ? "" : "hidden"
                  }`}
                  classNamePrefix="select"
                  placeholder="Vælg hold"
                  styles={{
                    control: (baseStyles, state) => ({
                      ...baseStyles,
                      cursor: "pointer",
                      width: 300,
                    }),
                    option: (baseStyles, state) => ({
                      ...baseStyles,
                      backgroundColor: state.isFocused ? "whitesmoke" : "white",
                      color: "black",
                    }),
                    container: (baseStyles, state) => ({
                      ...baseStyles,
                      marginTop: 10,
                    }),
                    placeholder: (baseStyles, state) => ({
                      ...baseStyles,
                      color: "#3A3A3A",
                      fontSize: 20,
                    }),
                  }}
                />
              </div>
            </div>
            {!this.state.loading ? (
              <div className="dashboard-views">
                {this.state.currentWeek === 0 ? (
                  <DashboardPreCampaign
                    campaign={this.state.campaign}
                    company={this.state.currentCompany}
                    highscore={this.state.highscore}
                  />
                ) : this.state.view == "league" ? (
                  <>
                    <DashboardStanding
                      leagues={this.state.shownLeagues}
                      currentWeek={this.state.currentWeek}
                      weekAmount={this.state.leagues[0]?.weekAmount}
                      changeCurrentWeek={this.changeCurrentWeek}
                      rankTeams={this.rankTeams}
                    />
                    <DashboardStats
                      companyhighscore={this.state.companyhighscore}
                      company={this.state.currentCompany}
                      highscore={this.state.highscore}
                    />
                    <DashboardMatchups
                      leagues={this.state.shownLeagues}
                      currentWeek={this.state.currentWeek}
                      weekAmount={this.state.leagues[0]?.weekAmount}
                      changeCurrentWeek={this.changeCurrentWeek}
                      getTeamAveragePoints={this.getTeamAveragePoints}
                      findTeam={this.findTeam}
                      getWeekAveragePointsLeagueTeams={
                        this.getWeekAveragePointsLeagueTeams
                      }
                      currentLeague={this.state.currentLeague}
                      currentLeagueIdx={this.state.currentLeagueIdx}
                    />
                  </>
                ) : (
                  <>
                    <DashboardStanding
                      leagues={this.state.shownLeagues}
                      currentWeek={this.state.currentWeek}
                      weekAmount={this.state.leagues[0]?.weekAmount}
                      changeCurrentWeek={this.changeCurrentWeek}
                      teamSelected={this.state.teamSelected}
                      rankTeams={this.rankTeams}
                      campaign={this.state.currentCompany}
                    />
                    <DashboardStats
                      companyhighscore={this.getTeamRankData()}
                      company={this.state.teamSelected}
                      highscore={{
                        highscore: this.state.highscore?.highscore?.filter(
                          (u) => u.teamId === this.state.teamSelected?.id,
                        ),
                      }}
                    />
                    <DashboardTeamMatchups
                      leagues={this.state.shownLeagues}
                      currentWeek={this.state.currentWeek}
                      weekAmount={this.state.leagues[0]?.weekAmount}
                      changeCurrentWeek={this.changeCurrentWeek}
                      teamSelected={this.state.teamSelected}
                      getTeamAveragePoints={this.getTeamAveragePoints}
                      findTeam={this.findTeam}
                      getWeekAveragePointsLeagueTeams={
                        this.getWeekAveragePointsLeagueTeams
                      }
                      currentLeague={this.state.currentLeague}
                      currentLeagueIdx={this.state.currentLeagueIdx}
                    />
                  </>
                )}
              </div>
            ) : (
              <div className="choose-campaign">
                {this.state.currentCompany ? (
                  <div className="loader-container">
                    <div className="loader-spinner"></div>
                  </div>
                ) : (
                  <div></div>
                )}
              </div>
            )}
          </div>
        </section>
      </>
    );
  }
}
